import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../providers/logincontext';

const PublicOnlyRoute = () => {
  const { accessToken } = useAuth();
  return accessToken ? <Navigate to="/projects" replace /> : <Outlet />;
};

export default PublicOnlyRoute;
